// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"3023eaad","692":"6f57e96c"}[chunkId] + ".chunk.js";
};